<template>
  <div class="locations-calculator-wrapper my-60">
    <div class="locations-calculator-wrapper-title">
      <h2 class="vz-text-align-left">Рассчитать доставку груза</h2>
      <div class="locations-calculator-wrapper-time">
        <vz-icon
          variant="light-green"
          url="/svg/vz-time.svg"
          class="mr-5"
        />
        Местное время {{ fromTime }}
      </div>
    </div>
    <slot />
    <p class="mt-30">
      Чтобы узнать стоимость и сроки доставки введите параметры груза в онлайн-калькулятор.
    </p>
  </div>
</template>

<script setup lang="ts">
import { useDayjs } from '#dayjs'
import {storeToRefs} from "pinia";
import {useCityStore} from "~/stores/city";
const dayjs = useDayjs()
const { from } = storeToRefs(useCityStore())

const fromTime = computed(() => {
  return dayjs.utc().add(from.value.timezone || 0, 'hours').format('HH:mm')
})
</script>

<style lang="scss" scoped>
.locations-calculator-wrapper {
  &-title {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: start;

    @media only screen and (max-width: $pub-xs) {
      flex-direction: column;
    }

    h2 {
      margin-bottom: 0;

      @media only screen and (max-width: $pub-xs) {
        margin-bottom: 10px;
      }
    }
  }

  &-time {
    display: flex;
    font-weight: bold;
    color: $light-green;
    align-items: center;
  }
}
</style>
